/**
 * USkin index
 */

import Breadcrumb from '../js/components/breadcrumb/index';
import Button from '../js/components/button/index';
import ButtonGroup from '../js/components/button-group/index';
import Calendar from '../js/components/calendar/index';
import Dropdown from '../js/components/dropdown/index';
import DropdownButton from '../js/components/dropdown-button/index';
import InputNumber from '../js/components/input-number/index';
import InputSearch from '../js/components/input-search/index';
import Menu from '../js/components/menu/index';
import Modal from '../js/components/modal/index';
import Notification from '../js/components/notification/index';
import Pagination from '../js/components/pagination/index';
import Panel from '../js/components/panel/index';
import Slider from '../js/components/slider/index';
import Step from '../js/components/step/index';
import Switch from '../js/components/switch/index';
import Tab from '../js/components/tab/index';
import Table from '../js/components/table/index';
import Tip from '../js/components/tip/index';
import Tooltip from '../js/components/tooltip/index';

const uskin = {
  Breadcrumb,
  Button,
  ButtonGroup,
  Calendar,
  Dropdown,
  DropdownButton,
  InputNumber,
  InputSearch,
  Menu,
  Modal,
  Notification,
  Pagination,
  Panel,
  Slider,
  Step,
  Switch,
  Tab,
  Table,
  Tip,
  Tooltip
};

module.exports = uskin;



// WEBPACK FOOTER //
// ./js/uskin.js